import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import LeadsPage from "@/pages/LeadsPage";
import AdmissionsPage from "@/pages/AdmissionsPage";
import StudentsPage from "@/pages/StudentsPage";
import CoursesPage from "@/pages/CoursesPage";
import BatchesPage from "@/pages/BatchesPage";
import FacultyPage from "@/pages/FacultyPage";
import TimetablePage from "@/pages/TimetablePage";
import AttendancePage from "@/pages/AttendancePage";
import FeesPage from "@/pages/FeesPage";
import TestsPage from "@/pages/TestsPage";
import AssignmentsPage from "@/pages/AssignmentsPage";
import MaterialsPage from "@/pages/MaterialsPage";
import NotificationsPage from "@/pages/NotificationsPage";
import HRPage from "@/pages/HRPage";
import AccountingPage from "@/pages/AccountingPage";
import BranchesPage from "@/pages/BranchesPage";
import UsersPage from "@/pages/UsersPage";
import MyPortalPage from "@/pages/MyPortalPage";
import BroadcastPage from "@/pages/BroadcastPage";
import QuestionBankPage from "@/pages/QuestionBankPage";
import ExamAdminPage from "@/pages/ExamAdminPage";
import ExamPortalPage from "@/pages/exam/ExamPortalPage";
import ExamAttemptPage from "@/pages/exam/ExamAttemptPage";
import ExamResultPage from "@/pages/exam/ExamResultPage";
import { useAuth } from "@/context/AuthContext";
import { useLocation } from "react-router-dom";
import "@/App.css";

function ExamGuard({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-[#F4F2EE] text-[#00000099]">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace state={{ from: location }}/>;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* Exam portal (own header, no sidebar) */}
          <Route path="/exam" element={<ExamGuard><ExamPortalPage /></ExamGuard>} />
          <Route path="/exam/attempt/:sessionId" element={<ExamGuard><ExamAttemptPage /></ExamGuard>} />
          <Route path="/exam/result/:testId" element={<ExamGuard><ExamResultPage /></ExamGuard>} />

          <Route element={<AppLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/my-portal" element={<MyPortalPage />} />
            <Route path="/broadcast" element={<BroadcastPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/admissions" element={<AdmissionsPage />} />
            <Route path="/students" element={<StudentsPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/batches" element={<BatchesPage />} />
            <Route path="/faculty" element={<FacultyPage />} />
            <Route path="/timetable" element={<TimetablePage />} />
            <Route path="/attendance" element={<AttendancePage />} />
            <Route path="/fees" element={<FeesPage />} />
            <Route path="/tests" element={<TestsPage />} />
            <Route path="/question-bank" element={<QuestionBankPage />} />
            <Route path="/exam-admin" element={<ExamAdminPage />} />
            <Route path="/assignments" element={<AssignmentsPage />} />
            <Route path="/materials" element={<MaterialsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/hr" element={<HRPage />} />
            <Route path="/accounting" element={<AccountingPage />} />
            <Route path="/branches" element={<BranchesPage />} />
            <Route path="/users" element={<UsersPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
